/**
 * "Powered by TourneyNation" lockup.
 *
 * Always rendered. No props for visibility — the design doc §11 makes
 * this an integral part of the visual identity, not an attribution
 * toggle. Consumes the --tn-lockup-* tokens, which default to the theme's
 * muted/main text over a transparent background so it blends with any
 * organizer palette instead of painting its own strip.
 */
import './Lockup.css';

export function Lockup() {
  return (
    <div className="tn-lockup" role="contentinfo">
      Powered by{' '}
      <a
        href="https://tourneynation.com"
        target="_blank"
        rel="noopener noreferrer"
        className="tn-lockup__link"
      >
        TourneyNation
      </a>
    </div>
  );
}
